import './config/publicPath'; // Should be at the very beginning of entry

import domReady from '@wordpress/dom-ready';
import detectTouchSupport from './modules/detectTouchSupport';

const addPlaceholdersToInputs = () => {
  const labels = document.querySelectorAll('label');

  labels.forEach((label) => {
    const inputId = label.getAttribute('for');
    const inputElement = document.getElementById(inputId);

    if (
      inputElement &&
      (inputElement.type === 'text' || inputElement.type === 'password')
    ) {
      inputElement.setAttribute('placeholder', label.textContent);
    }
  });
};

domReady(() => {
  detectTouchSupport();
  addPlaceholdersToInputs();
});
